import React from 'react';
import { Trash2Icon, HammerIcon, HardHatIcon, WarehouseIcon, SprayCanIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const icons = [Trash2Icon, HammerIcon, HardHatIcon, WarehouseIcon, SprayCanIcon];
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="w-full bg-white py-20 lg:py-28" data-id="element-171" data-mp="18x253xw441cs">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-172" data-mp="13wmuvf74n9z1">
        <div className="max-w-2xl" data-id="element-173" data-mp="z5ejweq5fgjr">
          <h2 className="font-display text-3xl font-black tracking-tight text-forest sm:text-4xl lg:text-5xl" data-id="element-174" data-mp="z43de75bjuoy">
            {t.services.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-neutral-600" data-id="element-175" data-mp="q4gfvwfpn916">
            {t.services.intro}
          </p>
        </div>

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-176" data-mp="l5n1m1slndzy">
          {t.services.items.map((service, index) => {
          const Icon = icons[index];
          return <li key={service.title} className="h-full" data-id="element-177" data-mp="36beu42uwjlkt" data-mpi={index}>
                <a href="#contact" className="group flex h-full flex-col rounded-lg border border-neutral-200 bg-sand p-7 transition-[border-color,background-color,transform] duration-200 ease-out hover:-translate-y-1 hover:border-rust hover:bg-white" data-id="element-178" data-mp="3b369ricis6w6">
                  <span className="mb-6 flex h-12 w-12 items-center justify-center rounded-md bg-forest text-white transition-colors duration-200 ease-out group-hover:bg-rust" data-id="element-179" data-mp="3q0gsncrhsf1x">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-180" data-mp="3tzxyw8eqtg85" />
                  </span>
                  <h3 className="font-display text-xl font-bold text-forest" data-id="element-181" data-mp="3g4dibjmhla3w">
                    {service.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-neutral-600" data-id="element-182" data-mp="24ndup1b33jg7">
                    {service.description}
                  </p>
                  <span className="mt-auto flex items-center gap-2 pt-6 text-sm font-bold text-rust" data-id="element-183" data-mp="29ns0ecp7qhb2">
                    {t.services.cardCta}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-184" data-mp="1lir42ttajggx" />
                  </span>
                </a>
              </li>;
        })}

          <li className="h-full" data-id="element-185" data-mp="16tl2x0aw7g6e">
            <div className="flex h-full flex-col justify-between rounded-lg bg-forest p-7" data-id="element-186" data-mp="16unu79c4nkmu">
              <div data-id="element-187" data-mp="11u8h8ivrcf5e">
                <h3 className="font-display text-xl font-bold text-white" data-id="element-188" data-mp="11syj5town6yr">
                  {t.services.promptTitle}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-white/75" data-id="element-189" data-mp="sttlepl63hnn">
                  {t.services.promptBody}
                </p>
              </div>
              <a href="#contact" className="mt-6 inline-flex w-full items-center justify-center rounded-md bg-rust px-5 py-3 text-center text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-rust-dark" data-id="element-190" data-mp="2s6fkvazvsqcp">
                {t.services.promptCta}
              </a>
            </div>
          </li>
        </ul>
      </div>
    </section>;
}